(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rubberdukky-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  const arrow = event.target.closest('[data-rd-lineup-direction]');
  if (!arrow) return;
  const card = arrow.closest('.rd-lineup__card');
  if (!card) return;
  const photos = card.querySelectorAll('[data-rd-lineup-image]');
  if (!photos.length) return;
  const current = Number(card.dataset.rdImageIndex || 0);
  const next = (current + Number(arrow.dataset.rdLineupDirection) + photos.length) % photos.length;
  const image = card.querySelector('.rd-lineup__main');
  image.src = photos[next].dataset.src;
  image.alt = photos[next].dataset.alt;
  card.dataset.rdImageIndex = String(next);
  card.querySelector('[data-rd-lineup-status]').textContent = 'Photo ' + (next + 1) + ' of ' + photos.length;
});
  } catch(e) { console.error(e); }
})();

})();
